import {Component,OnInit} from "@angular/core";
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {TranslateService} from "@ngx-translate/core";
import {MessageNotif} from "@domain/notification/message-notif";
import {MessageNotifListItemComponent} from "./message-notif-list-item/message-notif-list-item.component";
import {BehaviorSubject} from 'rxjs';
import {FloatingButtonAction,TypeAction} from '@share/component/floating-button/floating-button';
import {Router} from "@angular/router";
import {TypeMessageNotif} from "@domain/notification/type-message-notif";
import {Sorting} from "@domain/common/list-view/sorting";

/**
 * Onglet notification messages
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'notification-messages'},
    templateUrl: './notification-messages.component.html'
})
export class NotificationMessagesComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Liste des messages */
    listeMessages: ListView<MessageNotif, MessageNotifListItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service des traductions
     * @param router Routeur Angular
     */
    constructor(private translateService: TranslateService,
                private router: Router) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Initialisation de la ListView
        this.listeMessages = new ListView<MessageNotif, MessageNotifListItemComponent>({
            title: this.translateService.instant('admin.bibliotheque.notifications.message.title'),
            uri: '/controller/MessageNotif/search/usage',
            defaultOrder: 'titre',
            isSearchWhenNoFilter: true,
            showPagination: true,
            component: MessageNotifListItemComponent,
            isFilter: true,
            isSearchBar: true,
            isFilterVisible: true,
            listeFilters: [
                {
                    clef: 'titre',
                    title: this.translateService.instant('admin.bibliotheque.notifications.message.filtres.titre'),
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true,
                    type: TypeFilter[TypeFilter.STRING]
                },
                {
                    clef: 'sujet',
                    title: this.translateService.instant('admin.bibliotheque.notifications.message.filtres.sujet'),
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    isDefault: true,
                    type: TypeFilter[TypeFilter.STRING]
                },
                {
                    clef: 'type',
                    title: this.translateService.instant('admin.bibliotheque.notifications.message.labels.type'),
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    listeValues: [
                        { code: TypeMessageNotif.EMAIL, libelle: this.translateService.instant('admin.bibliotheque.notifications.message.type.email') },
                        { code: TypeMessageNotif.CONFIRMATION, libelle: this.translateService.instant('admin.bibliotheque.notifications.message.type.confirmation') }
                    ]
                },
                {
                    clef: '#usage',
                    title: this.translateService.instant('admin.bibliotheque.notifications.message.labels.utilise'),
                    type: TypeFilter[TypeFilter.BOOLEAN],
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                }
            ]
        });

        //Définition des colonnes de tri
        this.listeMessages.columns = [
            {key: 'titre',title: 'admin.bibliotheque.notifications.message.filtres.titre'},
            {key: 'sujet',title: 'admin.bibliotheque.notifications.message.filtres.sujet'},
            {key: 'type',title: 'admin.bibliotheque.notifications.message.labels.type'}
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeMessages.sorting = new Sorting(this.listeMessages.columns,"titre");

        //Persistence des filtres
        this.listeMessages.isPersistFilters = true;
        this.listeMessages.className = 'NotificationMessagesComponent';

        //Liste des actions
        this.listeActions.next([{
                type: TypeAction.PRIMARY,
                icone: 'nio icon-ajouter',
                libelle: 'global.actions.creer',
                doAction: () => this.createNewMessage()
            }]
        );
    }

    /**
     * Création d'un nouveau message
     */
    createNewMessage() {
        this.router.navigate(['Admin/Bibliotheque/Notification/Message/0']);
    }
}